import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import { fetchPests } from 'catalog/actions/pest';
import { createEntityNode } from 'catalog/actions/node';
import NodeSourcePage from './NodeSourcePage';

const mapStateToProps = state => ({
  entities: state.catalog.pests,
  info: 'Sélectionnez un nuisible pour créer un noeud à partir de ce dernier.',
  link: '/pests/new',
});
const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchEntities: () => dispatch(fetchPests()),
  createNode: pest =>
    dispatch(
      createEntityNode(ownProps.catalog, ownProps.params.id, 'pest', pest)
    ),
  redirectToParent: () => dispatch(replace(`/nodes/${ownProps.params.id}`)),
});

export default connect(mapStateToProps, mapDispatchToProps)(NodeSourcePage);



// WEBPACK FOOTER //
// ./src/modules/catalog/pages/NodePestsPage.js